import { FC, useState } from 'react';
import { Box, SvgIconTypeMap } from '@mui/material';

import styles from 'features/contract-page/ui/styles/MainInfo.module.css';
import CheckIcon from '@mui/icons-material/Check';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface IClickToCopy {
    value: string;
    displayValue: string;
    icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
}

const ClickToCopy: FC<IClickToCopy> = ({ value, displayValue, icon: Icon }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
        setTimeout(() => setCopied(false), 300);
      }, 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
        setTimeout(() => setCopied(false), 300);
      }, 2000);
    }
  };
  return (
    <Box className={styles.copyContainer}>
      <Box className={styles.curatorInfo}>
        <span><Icon /></span>
        <p 
          className={styles.copyableText}
          onClick={handleCopy}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && handleCopy()}
        >
          {displayValue || value}
        </p>
        {showTooltip && (
          <Box className={`${styles.tooltip} ${copied ? styles.tooltipVisible : ''}`}>
            {copied ? (
              <>
                <CheckIcon className={styles.checkIcon} />
                Скопировано!
              </>
            ) : (
              'Нажмите для копирования'
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ClickToCopy;